import { onceConsented } from "@telia/b2x-cookie-consent";
import { inject as injectInzynk } from "@telia/b2x-inzynk";
import { rule } from "@telia/b2x-url-segments";

import { INZYNK_TAG_UID_B2B } from "../constants";

export const initInzynk = () => {
  onceConsented("C0004", "B2B Account Based marketing").then(() => {
    const r = rule(new URL(window.location.href));

    if (r.isB2B && r.isPublic) {
      injectInzynk(INZYNK_TAG_UID_B2B);
    }
  });
};
